import {runElectronFunc} from "./comm";

function showNoti(targetWindowId) {
    runElectronFunc('ElectronWindowApi', 'openFlashFrame', targetWindowId && targetWindowId !== 'noti_post' ? ("POPUP_CHAT_" + targetWindowId) : "MAIN" );
}

function hideNoti(targetWindowId) {
    runElectronFunc('ElectronWindowApi', 'hideFlashFrame',  targetWindowId ? ("POPUP_CHAT_" + targetWindowId) : "MAIN" );
}

function showDenyNoti(props) {
    try {
        if (Notification.permission === 'denied') {
            window.ElectronNotiApi.browserCustomNoti({category: "cnpl", param: props});
        }
    } catch (e) {
        Often.toast('error', i18next.t(main.alert.errorTryAgain));
    }
}

export {
    showNoti,
    hideNoti,
    showDenyNoti
};